import { ChangeEventHandler } from 'react';
import {
  Grid, Paper, Stack, TextField, Typography,
} from '@mui/material';
import { v4 as uuid } from 'uuid';
import BlockProps from '../../../models/BlockProps';
import BlockMapData from './BlockMapData';
import CloseButton from '../../Buttons/Close';
import EditableText from '../../Form/EditableText';
import Utils from '../../../utils/Utils';

function BlockMap({
  data, isEditing, isTemplate, editHandler,
}: BlockProps) {
  const props = (data.data as BlockMapData);

  const handleHtml: ChangeEventHandler<HTMLInputElement> = (event) => {
    props.html.value = event.target.value;
  };

  const handleBlur: ChangeEventHandler<HTMLInputElement | HTMLTextAreaElement> = (event) => {
    props.html.value = event.target.value;
    editHandler(data.id, props);
  };

  return (
    <Stack
      spacing={0}
      style={{
        overflow: 'hidden',
      }}
    >
      {(isEditing && !isTemplate) && (
        <Stack spacing={0} sx={{ border: '1px dashed lightGray', p: 2, m: 2 }}>
          <TextField
            sx={{
              '& textarea': {
                resize: 'vertical',
              },
            }}
            key={uuid()}
            label="iFrame"
            multiline
            rows={4}
            defaultValue={props.html?.value}
            onChange={handleHtml}
            onBlur={handleBlur}
          />
        </Stack>
      )}

      <Grid
        container
        spacing={0}
        direction="column"
        alignItems="center"
        justifyContent="center"
        className="block-content-wrapper"
      >
        <Grid
          container
          direction="column"
          sx={{
            justifyContent: 'center', alignItems: 'center', p: 2,
          }}
        >
          {props.html?.value && (
            <div style={{ width: '100%' }} dangerouslySetInnerHTML={{ __html: props.html.value }} />
          )}
          {!props.html?.value && (
            <Paper
              elevation={0}
              sx={{
                height: 450, background: '#F4F4F6', border: '1px dashed lightGray', width: '100%', maxWidth: '600',
              }}
            >
              <div
                style={{
                  width: '100%', height: '100%', display: 'flex', justifyContent: 'center', alignItems: 'center', textAlign: 'center',
                }}
              >
                <Typography variant="h1" color="#E6E6E9">地図</Typography>
              </div>
            </Paper>
          )}
          {props.text && (
            <Grid item sx={[Utils.hoverBorder(isEditing), { marginTop: 2 }]}>
              {isEditing && (
                <CloseButton updateHandler={() => {
                  props.text = undefined;
                  editHandler(data.id, props);
                }}
                />
              )}
              <EditableText
                text={props.text?.value}
                textColor={props.text?.settings?.textColor}
                isEditable={isEditing && !isTemplate}
                updateHandler={(newText) => {
                  props.text.value = newText;
                  editHandler(data.id, props);
                }}
              />
            </Grid>
          )}
        </Grid>
      </Grid>
    </Stack>
  );
}

export default BlockMap;
